export default __webpack_public_path__ + "static/media/client2.a1f4e827.png";